import dayjs from "dayjs";

export const differenceInDays = (date1: string, date2?: string) => {
  return dayjs(date2).diff(dayjs(date1), "day");
};

export const formatDate = (date: string) => {
  return dayjs(date).format("MMM D, YYYY");
};

/**
 * Check if date is today
 */
export const isToday = (dateStr: string): boolean => {
  return dayjs(dateStr).isSame(dayjs(), "day");
};

/**
 * Check if date is yesterday
 */
export const isYesterday = (dateStr: string): boolean => {
  return dayjs(dateStr).isSame(dayjs().subtract(1, "day"), "day");
};

/**
 * Check if date is within this month (but not today/yesterday)
 */
export const isThisMonth = (dateStr: string): boolean => {
  const date = dayjs(dateStr);
  const today = dayjs();
  return (
    date.month() === today.month() &&
    date.year() === today.year() &&
    !isToday(dateStr) &&
    !isYesterday(dateStr)
  );
};

/**
 * Check if date is within last N months
 */
export const isWithinMonths = (dateStr: string, months: number): boolean => {
  const date = dayjs(dateStr);
  const cutoff = dayjs().subtract(months, "month");
  return date.isAfter(cutoff) || date.isSame(cutoff, "day");
};

/**
 * Format date as relative (Today, Yesterday, or formatted date)
 */
export const formatRelativeDate = (dateStr?: string): string => {
  if (!dateStr) return "";
  if (isToday(dateStr)) return "Today";
  if (isYesterday(dateStr)) return "Yesterday";
  return formatDate(dateStr);
};
